const sectionsChart = document.querySelectorAll('.Chart_main_new');

const chartObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const section = entry.target;

      section
        .querySelector('.Chart_block_pipe_1_new')
        ?.classList.add('active');

      section
        .querySelector('.Chart_block_pipe_2_new')
        ?.classList.add('active');
    }
  });
}, {
  threshold: 0.5
});

sectionsChart.forEach((section) => {
  chartObserver.observe(section);
});